export const getImageFromBlogPost = (content, getBigImage) => {
  try {
    let regex = `(http)?s?:?(\/\/[^"']*\.(?:png|jpg|jpeg|gif|png|svg|tif|heic|webp|PNG|JPG|JPEG|GIF|PNG|SVG|TIF|HEIC|WEBP))`
    let imageFound = content.match(regex)
    if (imageFound && imageFound.length > 0) {
      imageFound = imageFound[0]

      if (!getBigImage) {
        if (imageFound.indexOf('s1600') >= 0) {
          imageFound = imageFound.replace('s1600', 's640')
        }
      }

      if (getBigImage) {
        let imagesRatios = ['s640', 's320', 's200', 's400']
        for (var i = 0; i < imagesRatios.length; i++) {
          if (imageFound.indexOf(imagesRatios[i]) >= 0) {
            imageFound = imageFound.replace(imagesRatios[i], 's1600')
            break
          }
        }
      }
      return imageFound
    } else {
      let img = getGoogleImageInPost(content)
      if (img) {
        return img
      } else {
        let reg = /d\/(?:\w|['-]\w)+/g
        let youtube = content.match(reg)
        if (youtube.length > 0) {
          let youtubeId = youtube[0].substring(2)
          return `https://img.youtube.com/vi/${youtubeId}/maxresdefault.jpg`
        } else {
          return 'https://uptodatewebdesign.s3.eu-west-3.amazonaws.com/uploads/photos-1607099283425.png'
        }
      }
    }
  } catch (err) {
    return 'https://uptodatewebdesign.s3.eu-west-3.amazonaws.com/uploads/photos-1607099283425.png'
  }
}


export const imageGallery = selector => {

  const checkjQueryInterval = setInterval(() => {
    if (typeof jQuery !== 'undefined') {
      clearInterval(checkjQueryInterval)
      runImageGallery(selector)
    }
  }, 100);

  const runImageGallery = () => {
    var imgLists = $(selector)
    for (var i = 0; i < imgLists.length; i++) {
      let $img = $(imgLists[i])
      let img = imgLists[i].querySelector('img')
      let imgSrc = img.src
      let imgId = img.id
      let aLink = imgLists[i].href
      if (imgSrc && aLink) {
        if (imgId.indexOf('BLOGGER_PHOTO_ID') >= 0 || imgSrc.indexOf('s320') >= 0) {
          $img.fadeOut(200, function () {
            let biggerImg = imgSrc.replace('s320', 's1600')
            img.setAttribute('src', biggerImg)
            img.setAttribute('width', '1600')
            $(this).fadeIn()
          })
        }
        if (imgSrc.substring(0, 50) === aLink.substring(0, 50)) {
          $img.attr('data-caption', img ? img.alt || '' : '')
          $img.attr('data-fancybox', 'gallery')
        } else {
          $img.attr('target', '_blank')
        }
      }
    }

    setTimeout(() => {
      $('[data-fancybox="gallery"]').fancybox({
        loop: true,
        arrows: true,
        infobar: true,
        smallBtn: 'auto',
        toolbar: true,
        thumbs: {
          autoStart: true,
        },
        mobile: {
          thumbs: {
            autoStart: false,
          },
        },
        buttons: ['zoom', 'slideShow', 'fullScreen', 'thumbs', 'close'],
      })
    }, 1000)
  }


}